var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookmark = function SvgBookmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 34C25.4723 34.0004 24.9655 33.7919 24.5905 33.42L18.0005 26.82L11.4605 33.34C11.1838 33.6357 10.8239 33.8405 10.4284 33.9272C10.0328 34.0139 9.62024 33.9785 9.24524 33.8257C8.87023 33.6729 8.55045 33.4099 8.32818 33.0714C8.10592 32.7328 7.99165 32.3349 8.00048 31.93V4C8.00048 3.46957 8.21119 2.96086 8.58626 2.58579C8.96134 2.21071 9.47004 2 10.0005 2H26.0005C26.5309 2 27.0396 2.21071 27.4147 2.58579C27.7898 2.96086 28.0005 3.46957 28.0005 4V32C28.0005 32.5304 27.7898 33.0391 27.4147 33.4142C27.0396 33.7893 26.5309 34 26.0005 34ZM26.0005 32V4H10.0005V31.93L18.0005 24L26.0005 32Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark.51f2a7d0.svg";
export { ForwardRef as ReactComponent };